import React from 'react';

import { useTranslate } from 'hooks/useTranslations';
import { useBranchFeature } from 'hooks/useBranchFeature';

import Modal from './Modal';
import CloseButton from './CloseButton';

type QRModalProps = {
  onClickOutside: () => void;
};

export const ScanQRCodeModal: React.FC<QRModalProps> = ({ onClickOutside }) => {
  const t = useTranslate();
  const { qrCode } = useBranchFeature();
  return (
    <Modal
      dataTestId="scan-qr-modal"
      variant="dark"
      onClickOutside={onClickOutside}
      className="flex flex-col justify-center items-center w-full max-w-[596px] px-8 relative py-10 text-center"
    >
      <CloseButton
        className="absolute right-5 top-5 z-50"
        onClick={onClickOutside}
      />
      <div className="mb-8">
        <h2 className="text-3xl font-bold uppercase mb-4">{t('scanQRCode')}</h2>
        <p>{t('pointYourCamera')}</p>
      </div>
      <div className="flex flex-col justify-center items-center w-96 h-96 border-2 border-solid border-neutral-100 mb-8 relative">
        {qrCode && (
          <img
            className="relative z-10"
            src={`data:image/png;charset=utf-8;base64,${qrCode}`}
            width="380"
            height="380"
            alt="QR Code"
          />
        )}
        <span className="absolute w-[352px] h-[384px] top-1/2 left-1/2 bg-white -translate-1/2" />
        <span className="absolute w-[384px] h-[352px] top-1/2 left-1/2 bg-white -translate-1/2" />
      </div>
      <p className="text-sm text-neutral-60">{t('augmentedRealityRequires')}</p>
    </Modal>
  );
};
